import TouchVelocity from './touchVelocity';
import Hammer from 'hammerjs';
import gsap from 'gsap';

// const DragHandler =
export default class {
	constructor(instanceDuration, holder) {
		this.holder = holder;
		this.screen = {};
		this.screen.type = 'mobile';
		this.duration = instanceDuration;
		this.stripPosX = 0;
		this.progressBarWidth = holder.querySelector('.controls__progress').offsetWidth;
		this.progress = holder.querySelector('.controls__progress');
		this.thumb = holder.querySelector('.controls__thumb');
		this.controls = holder.querySelector('.mobile-controls');
		this.video = holder.querySelector('video');
		this.isPaused = 0;
		this.movement = 0;
	}
	dragHandler = (a) => {
		this.isDragging = !0;
		this.movement = a.movement;
		this.updatePosition(a.movement);
		// this.updateUI();
	};

	events() {
		const a = {
				touchmove: this.dragHandler,
			},
			b = Hammer.DIRECTION_ALL;

		this.controls.addEventListener('touchstart', this.mouseDownHandler);
		this.touchVelocity = new TouchVelocity(this.holder.querySelector('.mobile-controls-wrap'), a, b);

		this.timeline = gsap.timeline({ paused: true });

		// this.timeline.to()

		this.timeline.to(
			[this.thumb],
			{
				x: '-11px',
				duration: 1,
				ease: 'none',
			},
			0,
		);
		this.timeline.to(
			this.progress,
			{
				x: '0%',
				duration: 1,
				ease: 'none',
			},
			0,
		);
		this.timeline.to(
			[this.controls],
			{
				x: -this.progressBarWidth,
				y: 0,
				duration: 1,
				ease: 'none',
			},
			0,
		);
		this.timeline.to(
			[this.holder.querySelectorAll('.video-segments')],
			{
				x: -this.progressBarWidth,
				y: 0,
				duration: 1,
				ease: 'none',
			},
			0,
		);
	}

	// Define the mouseDownHandler function.
	mouseDownHandler = (a) => {
		// Extract clientX from the event object and assign it to 'b'.
		const { clientX: b } = a;

		// // Find the closest elements with classes '.controls__marker' and '.controls__title' from the event target.
		// const c = a.target.closest('.controls__marker');
		// const d = a.target.closest('.controls__title');

		// // If either 'c' or 'd' exist, exit the function.
		// if (c || d) return;

		// // Check if the media is playing; if not, set 'shouldPlayAfterScrub' to true.
		// if (!this.isPaused) {
		// 	this.shouldPlayAfterScrub = true;
		// }

		// // Pause the media.
		// this.pause();

		// Set 'isMouseDown' to true and modify class list of 'controls'.
		this.isMouseDown = true;
		this.controls.classList.add('grabbing');

		// Update 'currentMouseX' with the value of 'b'.
		this.currentMouseX = b;

		// Calculate 'stripPosX' based on whether the screen type is 'desktop' or not.
		if (this.screen.type === 'desktop') {
			this.stripPosX = (this.currentMouseX / this.controlsWidth) * this.progressBarWidth;
		} else {
			this.stripPosX = this.progressBarWidth * this.timeline.progress();
		}

		// // Cancel the animation frame if 'velocityTicker' exists.
		// if (this.velocityTicker) {
		// 	cancelAnimationFrame(this.velocityTicker);
		// }

		// Call 'updatePosition' and 'updateUI' functions.
		this.updatePosition();
		this.updateUI();

		// Add event listeners for 'touchend', 'mouseup', and 'mousemove' events on the window.
		window.addEventListener('touchend', this.mouseUpHandler);
		// window.addEventListener('mouseup', this.mouseUpHandler);
		// window.addEventListener('mousemove', this.mouseMoveHandler);
	};

	// Define the mouseUpHandler function.
	mouseUpHandler = () => {
		// Remove event listeners for 'touchend', 'mouseup', and 'mousemove' events from the window.
		window.removeEventListener('touchend', this.mouseUpHandler);
		// window.removeEventListener('mouseup', this.mouseUpHandler);
		// window.removeEventListener('mousemove', this.mouseMoveHandler);

		// Remove the 'grabbing' class from 'controls'.
		this.controls.classList.remove('grabbing');

		// Reset 'currentMouseX' to null and 'isMouseDown' to false.
		this.currentMouseX = null;
		this.isMouseDown = false;

		// Check if there's any current movement.
		if (this.currentMovement) {
			// If there is, start an animation frame with 'velocityHandler'.
			// this.velocityTicker = requestAnimationFrame(this.velocityHandler);
		} else {
			// If there isn't, update the position.
			this.updatePosition();
		}
	};

	// updatePosition(a) {
	// 	console.log(a);
	// }

	tickHandler = () => {
		if (!this.timeline) return;
		this.updateUI();
	};

	start = () => {
		gsap.ticker.add(this.tickHandler);
	};
	stop = () => {
		gsap.ticker.remove(this.tickHandler);
	};

	updateUI = () => {
		this.updateTimelineProgress();
	};

	updateTimelineProgress = () => {
		if (!this.timeline) return;
		const a = this.video.currentTime / this.duration;
		this.timeline.progress(a);
	};

	play = () => {
		// if (!this.video.paused) return;
		//console.log('check1');
		if (!this.timeline) {
			return;
		}

		// this.video.load();
		console.log('drug handler play');
		console.trace();

		this.video
			.play()
			.then(() => {
				// this.playPauseToggle.classList.remove('is-paused'),
				// 	(this.isPaused = !1),
				console.log('START INIT');
				this.start();
				// 	b.dispatch('ESPN:OVI:PLAYER:PLAY');
			})
			.catch((a) => {});
	};
	pause = () => {
		// if (this.video.paused) return;
		this.video.pause();
		this.isPaused = !0;
		this.stop();
	};

	updatePosition = (a = 0) => {
		// If the screen type is mobile, 'd' is set to 'a', otherwise it is set to '-a'.
		const d = this.screen.type === 'mobile' ? a : a * -1;

		// Subtract 'd' from 'stripPosX' and reset a timer.
		this.stripPosX -= d;
		/* if (this.checkTimer) {
			clearTimeout(this.checkTimer);
		}
		this.checkTimer = setTimeout(this.slidingDetect, 50); */

		// Calculate a ratio 'b' of 'stripPosX' to 'progressBarWidth'.
		const b = this.stripPosX / this.progressBarWidth;

		// Ensure 'e' is between 0 and 1.
		const e = Math.min(Math.max(b, 0), 1);

		// Calculate 'c' as a time value based on the duration and the ratio 'e'.
		const c = this.duration * e;

		// Set the current time of the video to 'c' and update the progress of the timeline.
		gsap.set(this.video, {
			currentTime: c,
			overwrite: true,
		});
		gsap.set(this.timeline, {
			progress: b,
			overwrite: true,
		});

		// If 'c' is greater than 2 and the video opacity is not 1, set the video opacity to 1.
		/* if (c > 2 && this.video.style.opacity != 1) {
			this.video.style.opacity = 1;
		} */
	};
}
